import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';
import { getStorageSetting } from '../storage';

export const GET_PII_VALIDATION_CODES_REQUEST = 'GET_PII_VALIDATION_CODES_REQUEST';
export const GET_PII_VALIDATION_CODES_SUCCESS = 'GET_PII_VALIDATION_CODES_SUCCESS';
export const GET_PII_VALIDATION_CODES_FAILURE = 'GET_PII_VALIDATION_CODES_FAILURE';

function requestGetPiiValidationCodes() {
  return {
    type: GET_PII_VALIDATION_CODES_REQUEST
  };
}

function receiveGetPiiValidationCodes(piiValidationCodes) {
  return {
    type: GET_PII_VALIDATION_CODES_SUCCESS,
    piiValidationCodes
  };
}

function rejectGetPiiValidationCodes() {
  return {
    type: GET_PII_VALIDATION_CODES_FAILURE
  };
}

export function getPiiValidationCodes() {
  return (dispatch) => {
    const selectedClient = getStorageSetting('selectedClient');
    if (!selectedClient || !selectedClient.isPiiProtectionEnabled) {
      return dispatch(receiveGetPiiValidationCodes(null));
    }

    dispatch(requestGetPiiValidationCodes());

    const promise = () => ApiService
      .getPiiValidationCodes()
      .then((response) => {
        dispatch(receiveGetPiiValidationCodes(response.data));
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, rejectGetPiiValidationCodes));
        }
      });
    return promise();
  };
}
